// import PendingMessages from './realTimeMesssagesTypes/pendingMessages';
// import Notifications from './realTimeMesssagesTypes/Notifications';

const RealTimeMessagesReceiver = (message) => {
    const possibleMessages = {
      pending: (message) => {
        // PendingMessages(message)
      },
    };

    if (message.notification) {
      Notifications(message.notification);
    }

    if (!message.type || !possibleMessages[message.type]) {
      return;
    }

    possibleMessages[message.type](message);

};


const Notifications = ({ notificationName }) => {
  if (notificationName === 'OrderStatusChanged') {
    window.location.href = '/restaurante';
  }
}

export default RealTimeMessagesReceiver;